import React from 'react';

export default function OR() {
  return (
    <div className="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-v5-green-100 font-bold italic text-v5-green-700">
      <div className="mr-1">OR</div>
    </div>
  );
}
